export type CheckListStatus = 'idle' | 'success' | 'inactive' | 'inactiveSuccess' | 'fail';

export const CheckListStatus = {
  idle: 'idle',
  success: 'success',
  fail: 'fail',
  inactive: 'inactive',
  inactiveSuccess: 'inactiveSuccess',
};
